export default "__VITE_ASSET__BDF6UpjW__"